import { v2Request } from "../helpers/request";

export const getMyReferralStatus = () => {
  return v2Request(`/rewards/`);
};
export const getPendingReferralStatus = () => {
  return v2Request(`/rewards/pending`);
};
export const getRedemptionHistory = () => {
  return v2Request(`/rewards/history`);
};
export const redeemReferralReward = (payload: JObj) => {
  return v2Request(`/rewards/redeem`, {
    body: JSON.stringify(payload),
    method: "POST",
  });
};

// Public (no login): lets the signup page know whether to ask how someone heard about us.
export const getReferralProgramStatus = () => {
  return v2Request(`/users/referral-program-status`);
};

// ---- Admin: referral program controls ----

export const getReferralSettings = () => {
  return v2Request(`/admin/referrals/settings`);
};
export const updateReferralProgram = (enabled: boolean) => {
  return v2Request(`/admin/referrals/program`, {
    method: "PUT",
    body: JSON.stringify({ enabled }),
  });
};
export const addReferralExclusion = (type: string, value: string) => {
  return v2Request(`/admin/referrals/exclusions`, {
    method: "POST",
    body: JSON.stringify({ type, value }),
  });
};
export const removeReferralExclusion = (id: number) => {
  return v2Request(`/admin/referrals/exclusions/${id}`, {
    method: "DELETE",
  });
};
